import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { categoriesActions } from "../../redux/actions/categories";
import AddCategory from "./AddCategory";

const mapStateToProps = state => {
  return {
    catregory: state.category
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        ...categoriesActions
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddCategory);



// WEBPACK FOOTER //
// ./src/app/views/addCategory/index.js